module.exports = __webpack_public_path__ + "static/img/coupons.7e6dff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coupons.png
// module id = c4/e
// module chunks = 0